import React from 'react';
import classes from './Title.module.css';

const Title = () => {
  return (
    <div className={classes.background}>
        <span className={classes.text}>SPIKS курилка</span>
    </div>
  );
};

export default Title;